import { MAX_OCCUPANTS, MAXIMUM_INCOME, OCCUPANTS } from '../constants';

export const getPersonsOptions = (
  incomeEligibility = [],
  maxOccupants = MAX_OCCUPANTS,
) => {
  const selectedPersons = incomeEligibility.reduce((acc, row) => {
    if (row[OCCUPANTS]) {
      acc[row[OCCUPANTS]] = true;
    }
    return acc;
  }, {});

  return Array.from(new Array(maxOccupants)).map((_, index) => {
    const value = String(index + 1);
    const option = { label: `${value} Person(s)`, value };

    if (selectedPersons[value]) {
      option.disabled = true;
    }
    return option;
  });
};

export const getIsAddRowDisabled = (
  incomeEligibility = [],
  maxOccupants = MAX_OCCUPANTS,
) => {
  if (incomeEligibility.length >= maxOccupants) {
    return true;
  }

  return incomeEligibility.some(
    (row) => !row[OCCUPANTS] || !row[MAXIMUM_INCOME],
  );
};

export const parseMaxIncome = (value = '') => {
  const filteredString = value.replace(/[^\d]/g, '');
  const formattedIncome = Number(filteredString).toString().substring(0, 10);
  return formattedIncome === '0' ? '' : formattedIncome;
};

export const formatMaxIncome = (value = '') => {
  const filteredString = value.replace(/[^\d.]/g, '');
  const [wholeDollars = ''] = filteredString.split('.');

  const formattedIncome = new Intl.NumberFormat('en-US', {
    currency: 'USD',
    style: 'currency',
  })
    .format(wholeDollars)
    .replace('$', '');

  return formattedIncome === '0.00' ? '' : formattedIncome;
};
